const skipUndefinedValues = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

export default skipUndefinedValues
